import { Loader, MultiSelect, Select } from "@mantine/core";
import { useColors } from "../../../../../hooks/colors/useColors";
import { IconArrowNarrowDown } from "@tabler/icons";
import { MyH1 } from "../../../../UI/my-h1/MyH1";
import { useScheduleList } from "../../../../../hooks/react-query/useSchedules";
import { StepperButtons } from "./StepperButtons";
import { bookingStore } from "../../../../config/store/bookingStore";
import { useTranslation } from "next-i18next";
import { isMobile } from "react-device-detect";
import { Fragment } from "react";
import { Schedule } from "../../../../../constants/model/models";
import { isPhone } from "../../../../../constants/env";

export function FirstStep() {
  const {
    schedules,
    returnSpecialtyOptions,
    returnSpecialistOptions,
    schedulesAreLoading,
    returnServiceOptions,
    returnFilteredSpecialist,
  } = useScheduleList();

  const { colors } = useColors();
  const { stepperFields, updateStepperFields } = bookingStore((state) => state);
  const { t, i18n } = useTranslation("common");

  function onPickCategory(specialty: string | null) {
    if (specialty) {
      stepperFields.specialty = specialty;
      stepperFields.specialist = undefined;
      updateStepperFields({ ...stepperFields });
    }
  }

  function onPickSpecialist(
    specialistId: string | null,
    schedules: Schedule[]
  ) {
    if (specialistId && schedules.length > 0) {
      stepperFields.specialist = returnFilteredSpecialist(
        +specialistId,
        schedules
      );
      stepperFields.services = []
      updateStepperFields({ ...stepperFields });
    }
  }

  function onPickServices(services: string[], schedule: Schedule) {
    stepperFields.services = schedule.services.filter((service) =>
      services.includes(service.service)
    );
    updateStepperFields({ ...stepperFields });
  }


  // @ts-ignore
  return (
    <Fragment>
      <div className="flex justify-center gap-4 p-4 items-center">
        {schedulesAreLoading && <Loader />}
        {schedules && schedules.length > 0 && (
          <div className='flex flex-col justify-center items-center'>
            {/*<div className="m-4">*/}
            {/*  <MyH1 centerText size={isMobile ? "2rem" : "2.5rem"}>*/}
            {/*    {t("appointments.pickSpecialty")}*/}
            {/*  </MyH1>*/}
            {/*</div>*/}
            {/*<Select*/}
            {/*  size="xl"*/}
            {/*  style={{*/}
            {/*    item: { fontSize: "1.2rem" },*/}
            {/*    input: { fontSize: "1.2rem" },*/}
            {/*  }}*/}
            {/*  value={stepperFields.specialty}*/}
            {/*  onChange={onPickCategory}*/}
            {/*  // @ts-ignore*/}
            {/*  placeholder={t("appointments.pickSpecialty")}*/}
            {/*  data={returnSpecialtyOptions(schedules)}*/}
            {/*/>*/}

            {/*<div className="flex justify-center mt-8">*/}
            {/*  <IconArrowNarrowDown*/}
            {/*    size={50}*/}
            {/*    stroke={0.5}*/}
            {/*    color={colors.primary}*/}
            {/*  />*/}
            {/*</div>*/}
            <div className="mb-4">
              <MyH1 centerText size={isMobile ? "2rem" : "2.5rem"}>
                {t("appointments.pickSpecialist")}
              </MyH1>
            </div>
            <Select
                className={isPhone ? 'w-[90vw]' : 'max-w-[400px]'}
                searchable={!isPhone}
              // disabled={
              //   // returnSpecial
              //   // istOptions(schedules, stepperFields.specialty)
              //   //   .length === 0
              // }

              size='lg'
              style={{
                item: { fontSize: "1.2rem" },
                input: { fontSize: "1.2rem" },
              }}
                maxDropdownHeight={isPhone ? 300 : 400}
              value={stepperFields.specialist?.id.toString()}
              onChange={(value) => onPickSpecialist(value, schedules)}

              // @ts-ignore
              placeholder={t(
                isPhone
                  ? "appointments.pickSpecialist"
                  : "booking.specialist-write"
              )}
              data={returnSpecialistOptions(schedules, stepperFields.specialty)}
              // withScrollArea={false}
              styles={{ dropdown: { maxHeight: 450, overflowY: "auto" } }}
            />
            {stepperFields.specialist && (
              <Fragment>
                <div className="flex justify-center mt-8">
                  <IconArrowNarrowDown
                    size={50}
                    stroke={0.5}
                    color={colors.primary}
                  />
                </div>
                <div className="m-4">
                  <MyH1 centerText size={isMobile ? "2rem" : "2.5rem"}>
                    {t("appointments.pickService")}
                  </MyH1>
                </div>
                <MultiSelect
                  className={isPhone ? 'max-w-[90vw]' : 'max-w-[400px]'}
                  disabled={
                    returnServiceOptions(schedules, stepperFields.specialist)
                      .length === 0
                  }
                  size='lg'
                  style={{
                    item: { fontSize: "1.2rem" },
                    input: { fontSize: "1.2rem" },
                  }}
                  value={stepperFields.services.map((service) => service.service)}
                  // @ts-ignore
                  onChange={(value) =>
                    // @ts-ignore
                    onPickServices(value, stepperFields.specialist)
                  }
                  withScrollArea={false}
                  styles={{ dropdown: { maxHeight: 300, overflowY: "auto" } }}
                  // @ts-ignore
                  placeholder={i18n.t("appointments.pickService")}
                  data={returnServiceOptions(
                    schedules,
                    stepperFields.specialist
                  )}
                />
              </Fragment>
            )}
          </div>
        )}
      </div>
      <StepperButtons
        disabled={typeof stepperFields.specialist === "undefined"}
      />
    </Fragment>
  );
}
